import React from "react";
import { toComponent } from "./../questionHelpers";
import { serializeAnswers } from "./../answerHelpers";
import * as api from "./../api";
import storage from "general/poly/storage";
import { uriToId } from "general/utils";
import * as constants from "./../constants";

const initialState = {
  answers: {},
  submittedSurvey: false,
  validForm: false, // is the form filled?
  validSurvey: false, // is the survey valid?
};

const reducer = (state, action) => {
  switch (action.type) {

  case "toggle-answer": {
    const { name, value, questionsCount } = action.payload;

    const nextAnswers = {
      ...state.answers,
      [name]: value,
    };

    let nextValidForm = state.validForm;
    if (
      questionsCount === Object.keys(nextAnswers).length
      &&
      questionsCount === Object.entries(nextAnswers).filter(([, value]) => value.length).length
    ) {
      nextValidForm = true;
    } else {
      nextValidForm = false;
    }

    return {
      ...state,
      answers: nextAnswers,
      validForm: nextValidForm,
    };
  }

  case "set-validation-survey": {
    return {
      ...state,
      ...action.payload,
    };
  }

  } // end switch
};

const Survey = (props) => {
  const { survey } = props;
  const surveyId = uriToId(survey.resource_uri);

  const [state, dispatch] = React.useReducer(reducer, initialState);
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {

    props.callbacks.init();

  }, []);

  React.useEffect(() => {

    if (state.validSurvey) {
      storage.sessionStorage.setItem(constants.STORAGE_KEYS.data, JSON.stringify(state.answers));
      storage.sessionStorage.setItem(constants.STORAGE_KEYS.id, surveyId);
      props.callbacks.onValidSurvey();
    }

  }, [state.validSurvey]);

  const onChange = (event) => {
    const target = event.target;
    let value;
    let name;

    if (target.type === "checkbox") {
      name = target.dataset.questionId;
      let nextValues = [];
      if (Array.isArray(state.answers[name])) {
        nextValues = [...state.answers[name]];
      }

      value = target.name;
      if (target.checked) {
        nextValues.push(value);
      } else {
        nextValues = nextValues.filter((v) => v !== value);
      }

      value = nextValues;

    } else if (target.type === "radio") {
      value = target.id;
      name = target.dataset.questionId;
    } else if (target.type === "select-one") {
      value = target.value;
      name = target.name;
    }

    dispatch({
      type: "toggle-answer",
      payload: {
        name,
        value,
        questionsCount: survey.questions.length,
      },
    });
  };

  const handleOnSubmit = async (event) => {
    setLoading(true);
    event.preventDefault();

    const answers = serializeAnswers(state.answers);
    const response = await api.validateSurvey(surveyId, answers);

    let validSurvey;
    if (response && response.results) {
      validSurvey = true;
    } else {
      validSurvey = false;
    }

    window.dispatchEvent(
      new Event("reset-spinnery-buttons", { bubbles: true }),
    );

    dispatch({ type: "set-validation-survey", payload: { validSurvey, submittedSurvey: true } });
    setLoading(false);
  };

  return (
    <React.Fragment>
      {
        survey &&
          <fieldset>
            <legend
              className="gp-calendar__container__controls cf survey-title"
            >
              { survey.title }
            </legend>

            <div
              className="appointment-form survey-container"
            >
              <div
                className="survey-description"
              >
                { survey.description }
              </div>

              {
                state.submittedSurvey && !state.validSurvey &&
                <div
                  className="error-message survey-error"
                >{
                    survey.invalid_result_message
                      ? survey.invalid_result_message
                      : "Invalid Selection. Please try again."
                  }
                </div>
              }

              <hr />

              <form
                onSubmit={handleOnSubmit}
                onReset={() => {
                  props.callbacks.init({ reset: true });
                }}
                className="form-horizontal"
              >

                {
                  survey.questions.map((question, index) => (
                    <React.Fragment key={index}>
                      { toComponent(question, onChange) }
                    </React.Fragment>
                  ))
                }

                <form-actions>
                  <button
                    ord="primary"
                    type="submit"
                    disabled={loading || !state.validForm}
                    data-default_theme="true"
                  >
                    <rm-icon replace class="icon--svg-spinners icon--svg-spinners--ring-resize"></rm-icon>
                    <span>Submit</span>
                  </button>

                  <button
                    ord="secondary"
                    type="reset"
                    disabled={loading}
                    data-default_theme="true"
                  >
                    <rm-icon replace class="icon--svg-spinners icon--svg-spinners--ring-resize"></rm-icon>
                    <span>Cancel</span>
                  </button>

                </form-actions>

              </form>
            </div>
          </fieldset>
      }

    </React.Fragment>
  );
};

export default Survey;
